import React, { useState, useEffect, useMemo } from 'react';
import { 
    Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box, 
    Container, Grid, TextField, Autocomplete, Avatar, MenuItem, 
    Button, Chip, InputAdornment, Alert, useTheme, useMediaQuery, 
    Stack, CircularProgress, Paper, List, ListItem, ListItemText, ListItemSecondaryAction
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUserPlus, faSearch, faPlus, faTrash, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/es';
//import debounce from 'lodash.debounce';

import InlineEntityFinder from '../../../components/entities/InlineEntityFinder';

// Controllers
import { 
    getBookingFormOptions, checkAdminAvailability, createManualBooking 
} from '../../../controllers/company/MerchantBookingController';
import CreateEntityModal from '../../../components/entities/CreateEntityModal';
//import { SearchPerson } from '../../../controllers/company/crm/CustomersController';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewBookingModal({ open, onClose, onSuccess }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // --- ESTADOS DE DATOS ---
    const [options, setOptions] = useState({ services: [], employees: [] });
    //const [clientsList, setClientsList] = useState([]);
    const [slots, setSlots] = useState([]);

    // --- ESTADOS DE CARGA ---
    const [loadingOptions, setLoadingOptions] = useState(true);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // --- CARRITO DE RESERVAS ---
    const [client, setClient] = useState(null);
    const [showCreateClient, setShowCreateClient] = useState(false);
    const [bookingItems, setBookingItems] = useState([]); // Array de servicios añadidos

    // --- FORMULARIO TEMPORAL (Para añadir al carrito) ---
    const [service, setService] = useState(null); 
    const [employeeId, setEmployeeId] = useState('');
    const [date, setDate] = useState(moment());
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [notes, setNotes] = useState('');
    
    // --- EFECTOS ---
    useEffect(() => {
        if (open) {
            loadInitialData();
            // Reset global
            setClient(null); setBookingItems([]);
            resetTempForm();
        }
    }, [open]);

    useEffect(() => {
        if (date && employeeId && service) {
            loadAvailability();
        }
    }, [date, employeeId, service]);

    const resetTempForm = () => {
        setService(null);
        setSelectedSlot(null);
        setSlots([]);
        setNotes('');
        // Mantenemos employeeId y date por comodidad (si le va a hacer pelo y uñas el mismo día con la misma persona)
    };

    // --- FUNCIONES DE CARGA ---
    const loadInitialData = async () => {
        setLoadingOptions(true);
        const data = await getBookingFormOptions();
        setOptions(data);
        setLoadingOptions(false);
    };

    /*const handleSearchClient = useMemo(() => debounce(async (query) => {
        if (query.length > 2) {
            const results = await SearchPerson(query);
            setClientsList(Array.isArray(results.data) ? results.data : []);
        }
    }, 500), []);*/

    const loadAvailability = async () => {
        setLoadingSlots(true);
        setSelectedSlot(null);
        const dateStr = date.format('YYYY-MM-DD');
        const data = await checkAdminAvailability(dateStr, employeeId, service.duration);
        setSlots(data);
        setLoadingSlots(false);
    };

    // --- MANEJADORES ---
    const handleSlotClick = (slot) => {
        if (!slot.available) {
            const confirmForce = window.confirm(
                `⚠️ ALERTA DE CONFLICTO\n\nEste horario ya está ocupado por: ${slot.conflict_with || 'Otro cliente'}.\n\n¿Deseas FORZAR la reserva (Sobrecupo)?`
            );
            if (!confirmForce) return;
        }
        setSelectedSlot(slot);
    };

    // 1. AÑADIR AL CARRITO
    const handleAddItem = () => {
        if (!service || !selectedSlot) return;

        const dateStr = date.format('YYYY-MM-DD');
        const startDateTime = `${dateStr} ${selectedSlot.time}:00`;
        const duration = service.duration;
        const endDateTime = moment(startDateTime).add(duration, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        
        const employeeName = options.employees.find(e => e.id === employeeId)?.name || 'Cualquiera';

        const newItem = {
            product_id: service.id,
            employee_id: employeeId || null,
            start_datetime: startDateTime,
            end_datetime: endDateTime,
            notes: notes,
            // Datos UI (Solo para mostrar en el carrito)
            _ui_service_name: service.name || service.nombre,
            _ui_employee_name: employeeName,
            _ui_price: parseFloat(service.price || service.precio),
            _ui_time: selectedSlot.time
        };

        setBookingItems([...bookingItems, newItem]);
        resetTempForm(); // Limpiamos para que agregue el siguiente
    };

    // 2. ELIMINAR DEL CARRITO
    const handleRemoveItem = (index) => {
        const newItems = [...bookingItems];
        newItems.splice(index, 1);
        setBookingItems(newItems);
    };

    // 3. ENVIAR TODO AL BACKEND
    const handleSubmit = async () => {
        if (!client || bookingItems.length === 0) return;

        setSubmitting(true);
        
        // Limpiamos los datos de UI antes de enviar (opcional, pero más limpio)
        const cleanBookings = bookingItems.map(item => ({
            product_id: item.product_id,
            employee_id: item.employee_id,
            start_datetime: item.start_datetime,
            end_datetime: item.end_datetime,
            notes: item.notes
        }));

        const payload = {
            customer_id: client.id,
            bookings: cleanBookings
        };

        const response = await createManualBooking(payload);
        setSubmitting(false);

        if (response.success) {
            console.log('LO LOGRAMOSSS')
            onSuccess();
            onClose();
        } else {
            alert(response.message || 'Error al crear las citas');
        }
    };

    // --- CÁLCULO TOTAL ---
    const totalCart = bookingItems.reduce((sum, item) => sum + item._ui_price, 0);

    return (
        <Dialog 
            fullScreen={isMobile}
            maxWidth="lg" // Lo hicimos un poco más ancho para que quepa el formulario y el carrito lado a lado en PC
            fullWidth
            open={open} 
            onClose={onClose}
            TransitionComponent={Transition}
            PaperProps={{ sx: { bgcolor: '#f8f9fa' } }}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'white', color: 'text.primary', boxShadow: 'none', borderBottom: '1px solid #eee' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                        Agendar Citas
                    </Typography>
                </Toolbar>
            </AppBar>

            <Container maxWidth="xl" sx={{ py: 3, pb: 10 }}>
                <Grid container spacing={3}>
                    
                    {/* IZQUIERDA: FORMULARIO */}
                    <Grid item xs={12} md={8}>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                            <Stack spacing={3}>
                                
                                {/* 1. CLIENTE (Global) */}
                                <Paper sx={{ p: 2, borderRadius: 3, boxShadow: '0 2px 10px rgba(0,0,0,0.02)' }}>
                                    <Typography variant="subtitle2" color="text.secondary" fontWeight="bold" mb={1}>
                                        1. SELECCIONAR CLIENTE
                                    </Typography>
                                    <InlineEntityFinder 
                                        label="Buscar por nombre, cédula o email..."
                                        onSelectEntity={(entity) => {
                                            // Cuando el buscador encuentre uno, lo guardamos en el estado del carrito
                                            setClient(entity);
                                        }}
                                        onAddNew={() => {
                                            // Aquí abriremos el modal de crear persona (que haremos en el siguiente paso)
                                            setShowCreateClient(true);
                                        }}
                                    />

                                    {/* Pequeño feedback visual cuando ya hay un cliente seleccionado */}
                                    {client && (
                                        <Box mt={2} p={1.5} bgcolor="#e8f5e9" borderRadius={2} border="1px solid #c8e6c9" display="flex" alignItems="center" gap={1}>
                                            <FontAwesomeIcon icon={faCheckCircle} color="#2e7d32" />
                                            <Typography variant="body2" color="#2e7d32" fontWeight="bold">
                                                Cliente seleccionado: {client.name} {client.last_name || client.lastname}
                                            </Typography>
                                        </Box>
                                    )}
                                </Paper>

                                {/* 2. AÑADIR SERVICIO */}
                                <Paper sx={{ p: 2, borderRadius: 3, boxShadow: '0 2px 10px rgba(0,0,0,0.02)', opacity: client ? 1 : 0.5, pointerEvents: client ? 'auto' : 'none' }}>
                                    <Typography variant="subtitle2" color="text.secondary" fontWeight="bold" mb={2}>
                                        2. CONFIGURAR SERVICIO
                                    </Typography>
                                    
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                select
                                                fullWidth
                                                label="Servicio"
                                                value={service ? service.id : ''}
                                                onChange={(e) => {
                                                    const selected = options.services.find(s => s.id === e.target.value);
                                                    setService(selected);
                                                }}
                                            >
                                                {options.services.map(srv => (
                                                    <MenuItem key={srv.id} value={srv.id}>
                                                        {srv.name || srv.nombre} (${srv.price || srv.precio})
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                select
                                                fullWidth
                                                label="Profesional"
                                                value={employeeId}
                                                onChange={(e) => setEmployeeId(e.target.value)}
                                            >
                                                {options.employees.map(emp => (
                                                    <MenuItem key={emp.id} value={emp.id}>{emp.name}</MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <DatePicker
                                                label="Fecha"
                                                value={date}
                                                onChange={(val) => setDate(val)}
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                            />
                                        </Grid>

                                        {/* GRILLA DE HORARIOS */}
                                        <Grid item xs={12} sm={8}>
                                            {loadingSlots ? (
                                                <CircularProgress size={24} sx={{ mt: 2 }} />
                                            ) : (
                                                <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                                                    {slots.map((slot, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={slot.time}
                                                            onClick={() => handleSlotClick(slot)}
                                                            color={slot.available ? (selectedSlot?.time === slot.time ? 'primary' : 'default') : 'error'}
                                                            variant={selectedSlot?.time === slot.time ? 'filled' : 'outlined'}
                                                            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                        />
                                                    ))}
                                                    {!employeeId && <Typography variant="caption" color="text.secondary">Selecciona un profesional para ver horarios.</Typography>}
                                                </Box>
                                            )}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button 
                                                variant="outlined" 
                                                fullWidth 
                                                startIcon={<FontAwesomeIcon icon={faPlus} />}
                                                onClick={handleAddItem}
                                                disabled={!service || !selectedSlot}
                                                sx={{ py: 1.5, borderStyle: 'dashed', borderWidth: 2 }}
                                            >
                                                Añadir este servicio a la cita
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Paper>

                            </Stack>
                        </LocalizationProvider>
                    </Grid>

                    {/* DERECHA: EL CARRITO / RESUMEN */}
                    <Grid item xs={12} md={4}>
                        <Paper sx={{ p: 2, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', position: 'sticky', top: 20 }}>
                            <Typography variant="h6" fontWeight="bold" mb={2}>
                                Resumen de la Cita
                            </Typography>
                            
                            {client && (
                                <Box mb={2} p={1.5} bgcolor="grey.100" borderRadius={2}>
                                    <Typography variant="caption" color="text.secondary">Cliente</Typography>
                                    <Typography variant="subtitle2" fontWeight="bold">{client.name} {client.lastname}</Typography>
                                </Box>
                            )}

                            <List sx={{ mb: 2, minHeight: 150 }}>
                                {bookingItems.length === 0 ? (
                                    <Typography variant="body2" color="text.secondary" textAlign="center" mt={5}>
                                        No has añadido ningún servicio aún.
                                    </Typography>
                                ) : (
                                    bookingItems.map((item, index) => (
                                        <ListItem key={index} sx={{ bgcolor: 'white', border: '1px solid #eee', borderRadius: 2, mb: 1 }}>
                                            <ListItemText 
                                                primary={<Typography variant="subtitle2" fontWeight="bold">{item._ui_service_name}</Typography>}
                                                secondary={
                                                    <>
                                                        <Typography variant="caption" display="block">👤 {item._ui_employee_name}</Typography>
                                                        <Typography variant="caption" display="block">🕒 {moment(item.start_datetime).format('DD/MM/YY')} - {item._ui_time}</Typography>
                                                    </>
                                                }
                                            />
                                            <ListItemSecondaryAction>
                                                <Typography variant="subtitle2" fontWeight="bold" sx={{ mr: 2, display: 'inline-block' }}>
                                                    ${item._ui_price}
                                                </Typography>
                                                <IconButton edge="end" color="error" size="small" onClick={() => handleRemoveItem(index)}>
                                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                )}
                            </List>

                            <Box display="flex" justifyContent="space-between" alignItems="center" pt={2} borderTop="2px solid #eee" mb={3}>
                                <Typography variant="subtitle1" color="text.secondary">Total Estimado</Typography>
                                <Typography variant="h5" fontWeight="bold" color="primary.main">${totalCart.toFixed(2)}</Typography>
                            </Box>

                            <Button 
                                fullWidth 
                                variant="contained" 
                                size="large" 
                                onClick={handleSubmit}
                                disabled={bookingItems.length === 0 || !client || submitting}
                            >
                                {submitting ? 'Procesando...' : 'Confirmar Todo'}
                            </Button>
                        </Paper>
                    </Grid>

                </Grid>
            </Container>

            {/* SUB-MODAL: CREAR CLIENTE (Lo haremos en el siguiente paso) */}
            {showCreateClient && (
                <CreateEntityModal
                    open={showCreateClient}
                    onClose={() => setShowCreateClient(false)}
                    onSuccess={(newEntity) => {
                        // Cuando se cree, lo seleccionamos automáticamente
                        setClient(newEntity);
                        setShowCreateClient(false);
                    }}
                />
            )}
        </Dialog>
    );
}